(function () {
  function init(root) {
    var iso = root.dataset.launchIso;
    var target = new Date(iso).getTime();
    if (isNaN(target)) return;

    var els = {
      days: root.querySelector('[data-unit="days"]'),
      hours: root.querySelector('[data-unit="hours"]'),
      minutes: root.querySelector('[data-unit="minutes"]'),
      seconds: root.querySelector('[data-unit="seconds"]'),
    };
    var liveState = root.querySelector('[data-live-state]');
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

    var timer;
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        root.classList.add('password-splash--live');
        if (liveState) liveState.hidden = false;
        if (timer) clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (els.days)    els.days.textContent    = pad(d);
      if (els.hours)   els.hours.textContent   = pad(h);
      if (els.minutes) els.minutes.textContent = pad(m);
      if (els.seconds) els.seconds.textContent = pad(s);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function boot() {
    var roots = document.querySelectorAll('.password-splash[data-launch-iso]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
